import { render, staticRenderFns } from "./newTabsEdit.vue?vue&type=template&id=0ad36326&scoped=true&"
import script from "./newTabsEdit.vue?vue&type=script&lang=js&"
export * from "./newTabsEdit.vue?vue&type=script&lang=js&"
import style0 from "./newTabsEdit.vue?vue&type=style&index=0&id=0ad36326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad36326",
  null
  
)

export default component.exports